import { render, staticRenderFns } from "./chevron-left.vue?vue&type=template&id=4b1712d8&scoped=true"
import script from "./chevron-left.vue?vue&type=script&lang=js"
export * from "./chevron-left.vue?vue&type=script&lang=js"
import style0 from "./chevron-left.vue?vue&type=style&index=0&id=4b1712d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1712d8",
  null
  
)

export default component.exports